import React, { Component } from 'react';
import {Icon} from "@blueprintjs/core";

class PurchaseOrderLinesTable extends Component {

    render() {
        return (this.props.purchaseOrderLines.size > 0
                ? (
                    <table className="table">
                        <thead>
                        <tr className="d-flex">
                            <th className="col-3 " style={{borderBottom: 'none'}}>Producto</th>
                            <th className="col-3 " style={{borderBottom: 'none'}}>Almacén destino</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>Cantidad</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>Precio</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right', minWidth: 120}}>Descuento (%)</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>IVA (%)</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>Total</th>
                            <th className="col-1 " style={{borderBottom: 'none'}}></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.purchaseOrderLines.map((line, i) => {
                            return (
                                <tr className="d-flex" key={line.get('_id')} >
                                    <td className="col-3">{line.getIn(['product', 'name'])}</td>
                                    <td className="col-3">{line.getIn(['warehouse', 'name'])}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('amount')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('price')}</td>
                                    <td className="col" style={{ textAlign: 'right', minWidth: 120 }} >{line.get('discount')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('vat')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('total')}</td>
                                    <td className="col-1 d-flex justify-content-center">
                                        { this.props.editMode
                                            ? <Icon
                                                className="cursor-pointer"
                                                icon="trash"
                                                title="Eliminar"
                                                style={{marginLeft: 0}}
                                                onClick={() => this.props.deleteLine(i) }
                                            /> : null
                                        }
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                ) : 'No hay lineas de pedido.'
        );
    }

}

export default PurchaseOrderLinesTable;


// WEBPACK FOOTER //
// ./src/components/common/PurchaseOrderLinesTable.js